<template>
  <footer class="footer-modern">
    <p>
      &copy; {{ currentYear }}
      <span class="brand-text-accent">{{ $config.firstName }}</span
      >{{ $config.lastName }}
    </p>
  </footer>
</template>

<script>
export default {
  name: "FooterComp",
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>
<style scoped>
.footer-modern {
  /* Layout */
  width: 100%;
  padding: 1rem 0; /* Reduced padding for compactness */
  flex-shrink: 0; /* Important: Prevents footer from shrinking in flex/grid layouts */

  /* Appearance */
  background-color: #34495e; /* Dark, professional background */
  color: #bdc3c7; /* Light grey for copyright text */
  text-align: center;
  font-size: 0.95rem;
  font-weight: 500;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.2); /* Subtle top shadow */
  border-top: 3px solid var(--primary-color) !important; /* Clean accent line */

  /* Text container */
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer-modern p {
  margin: 0; /* Remove default margin from paragraph */
}

.brand-text-accent {
  color: var(--primary-color) !important; /* Accent color for the brand part */
  font-weight: 700;
  margin-left: 2px;
}

/* Optional: Slight animation on hover for a subtle touch */
.footer-modern:hover {
  background-color: #2c3e50;
}
</style>
